// extracted by mini-css-extract-plugin
export default {"articleCollapsed":"WyHFtrrjkaxdYsiygDGS","autoshipmentLogo":"drGs6WseyePsQv2HEEEA","quantity":"c6zUNDqftu6lMByinNAV"};